import { BrowserModule, Title } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule } from '@angular/common';
import { NgModule, APP_INITIALIZER, Injector } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DataTablesModule } from 'angular-datatables';

import { FullComponent } from './layouts/full/full.component';
import { BlankComponent } from './layouts/blank/blank.component';

import { NavigationComponent } from './shared/header-navigation/navigation.component';
import { SidebarComponent } from './shared/sidebar/sidebar.component';
import { BreadcrumbComponent } from './shared/breadcrumb/breadcrumb.component';

import { Approutes } from './app-routing.module';
import { AppComponent } from './app.component';
import { SpinnerComponent } from './shared/spinner.component';

import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { CoreModule } from './core/core.module';
import { ToastrModule } from 'ngx-toastr';
import { NgHttpLoaderModule } from 'ng-http-loader';
import { TranslateService } from './core/service/translate/translate.service';
import { AuthInterceptor } from './core/auth/auth-interceptor';
import { QuillModule } from 'ngx-quill';
import { OWL_DATE_TIME_LOCALE } from 'ng-pick-datetime';
import { LocalDataStorageService } from './core/service/local-data-storage.service';
import { LabelConfigPipe } from './core/pipe/labelConfig/label-config.pipe';
import { ConfirmDialogBoxModule } from './shared/confirm-dialog-box/confirm-dialog-box.module';
import { ConfirmationDialogComponent } from './shared/confirm-dialog-box/component/confirmation-dialog/confirmation-dialog.component';
import { SystemConfigService } from './system-config/service/system-config.service';
import { UserProfileComponent } from './modules/user-profile/user-profile.component';
import { ModuleParamGlobConfigService } from './core/service/moduleFieldConfig/module-param-glob-config.service';
import { AppDirectivesModule } from './app-derectives/app-derectives.module';
import { NumberFormatPipe } from './core/pipe/number-formate/number-format.pipe';
import { VendorAddUpdateComponent } from './core/component/vendor-add-update/vendor-add-update.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { VendorRegistrationModule } from './modules/vendor-registration/vendor-registration.module';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';


const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
  wheelSpeed: 1,
  wheelPropagation: true,
  minScrollbarLength: 20,
};
export let InjectorInstance: Injector;
@NgModule({
  declarations: [
    AppComponent,
    SpinnerComponent,
    FullComponent,
    BlankComponent,
    NavigationComponent,
    BreadcrumbComponent,
    SidebarComponent,
    UserProfileComponent,
    VendorAddUpdateComponent,
    
  ],
  imports: [
    QuillModule,
    CommonModule,
    BrowserModule,
    HttpModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    DataTablesModule,
    HttpClientModule,
    NgbModule,
    AppDirectivesModule,
    CoreModule,
    RouterModule.forRoot(Approutes, {
      useHash: true,
      preloadingStrategy: PreloadAllModules,
    }), 
    ToastrModule.forRoot(),
    PerfectScrollbarModule,
    NgHttpLoaderModule.forRoot(),
    ConfirmDialogBoxModule,
    NgSelectModule,
    VendorRegistrationModule,
    MatSlideToggleModule
  ],
  providers: [
    NumberFormatPipe,
    Title,
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG,
    },
    TranslateService,
    {
      provide: APP_INITIALIZER,
      useFactory: setupTranslateFactory,
      deps: [TranslateService],
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    { provide: OWL_DATE_TIME_LOCALE, useValue: 'en-IN' },
    LocalDataStorageService,
    LabelConfigPipe,
    SystemConfigService,
    ModuleParamGlobConfigService,
  ],
  bootstrap: [AppComponent],
  entryComponents: [ConfirmationDialogComponent],
})
export class AppModule {
  constructor(private injector: Injector) {
    InjectorInstance = this.injector;
  }
}

export function setupTranslateFactory(service: TranslateService): Function {
  return () => service.use('en');
}
